var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{attrs:{"type":"success","size":"sm","icon":"fa fa-plus fa-fw"},on:{"click":_vm.handleClick}},[_vm._v("Nuevo")])
}
var staticRenderFns = []

export { render, staticRenderFns }